import { getAccountService } from '../../services';
import { createAsyncAtom } from '../../lib/state';

const activeAccountIdAtom = createAsyncAtom<number>(async () => 0);

export function setActiveAccount(walletAddress: string, accountId: number) {
  const accountService = getAccountService();
  accountService.setActiveAccount(walletAddress, accountId);

  activeAccountIdAtom.setValue(accountId);
}

export { activeAccountIdAtom };
